export default {
      id: "whatsapp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }